/**
 * Whether the dossier can save, and why not. Every Save on the dossier (the
 * header control and the bottom bar) reads this one rule: the bottom
 * "Save (n)" ignored invalid entries and stayed clickable while the header
 * Save said "Fix 1 entry before saving" (nd3-35).
 *
 * `reasonRequired`/`reasonProvided` are the same shape for owner decision #8
 * (nd3-05): a hand-typed catalogue figure needs a one-line reason before
 * saving. Checked after invalid entries — a bad entry is fixed first, so the
 * person is never asked for a reason on a save that would fail anyway.
 */
export function dossierSaveState({
  dirtyCount,
  invalidCount,
  pending,
  reasonRequired = false,
  reasonProvided = true,
}: {
  dirtyCount: number
  invalidCount: number
  pending: boolean
  /** The pending changes hand-type a catalogue FIGURE (see
   *  `patchNeedsChangeReason`), so a one-line reason is required to save. */
  reasonRequired?: boolean
  /** A non-blank reason has been typed into the box. */
  reasonProvided?: boolean
}): { disabled: boolean; title: string | undefined } {
  const invalid = invalidCount > 0
  const missingReason = reasonRequired && !reasonProvided
  return {
    disabled: dirtyCount === 0 || pending || invalid || missingReason,
    title: invalid
      ? `Fix ${invalidCount} ${invalidCount === 1 ? 'entry' : 'entries'} before saving`
      : missingReason
        ? 'Add a one-line reason for the hand-typed figure before saving'
        : undefined,
  }
}
